import init from './init';

export default {
  init,
};
